// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__TGlEk","title":"index_title__eVMS1","btn":"index_btn__vx89q"};